"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AndroidShareSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<circle cx="10" cy="16" r="4"/><circle cx="22" cy="26" r="4"/><circle cx="22" cy="6" r="4"/><path d="M12.63 13a4.1 4.1 0 011.13 1.67l6.15-5.27A4 4 0 0118.53 8zM18.24 24.67A4.1 4.1 0 0119.37 23l-5.9-5a4 4 0 01-1.39 1.45l6.15 5.27z"/>';
var AndroidShareSVG = function AndroidShareSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.AndroidShareSVG = AndroidShareSVG;
AndroidShareSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(AndroidShareSVG);
exports.default = _default;